import React, { useContext, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { Loader, Segment } from 'semantic-ui-react';
import { AuthContext } from '../Auth/AuthContext';
import { CustomersContext } from '../Customers/CustomersContext';
import Leads from '../Customers/Sales/Leads/Leads';
import RFPList from '../Customers/Sales/RFP/RFPList';
import Prospects from '../Customers/Sales/Prospects/Prospects';
import Archive from '../Customers/Sales/Archive/Archive';
import Spinner from '../Shared/Spinner';

const Sales = () => {
	// context
	const { hasRoutes } = useContext( AuthContext );
	const {
		uiLoader,
		loadingMessage,
		spinner,
		setReadonlyModal
	} = useContext( CustomersContext );

	useEffect( () => {
		setReadonlyModal( !hasRoutes( 'writeSales' ) );
	}, [ hasRoutes, setReadonlyModal ] );

	return (
		<>
			<div className="titleHeader">
				{ uiLoader
					? <span>
						<Loader
							active
							inverted
							inline
							size="tiny"
							style={{
								marginRight: '0.5rem',
								marginBottom: '2px'
							}}
						/>
						{ loadingMessage }
					</span>
					: 'Sales'
				}
			</div>
			<div className="formContainer">
				<Segment
					basic
					style={{
						padding: '2rem',
						margin: '0 auto'
					}}
				>
					{ hasRoutes( 'leads' )
						&& <Route
							path="/main/sales"
							exact
							component={ Leads }
						/>
					}
					{	hasRoutes( 'rfp' )
					&& <Route
						path="/main/sales/rfp"
						component={ RFPList }
					/>
					}
					{ hasRoutes( 'prospects' )
						&& <Route
							path="/main/sales/prospects"
							component={ Prospects }
						/>
					}
					{ hasRoutes( 'archived' )
						&& <Route
							path="/main/sales/archived"
							component={ Archive }
						/>
					}
				</Segment>
			</div>
			<Spinner active={ spinner } />
		</>
	);
};

export default Sales;
